module.exports = __webpack_public_path__ + "static/media/invite-area-cake.75c6d108.webp";